import { postingsSellerControllerFactory } from '../find-work';

export default postingsSellerControllerFactory('recommended');
